import { Component, OnInit, Output, EventEmitter } from "@angular/core"
import { UntypedFormControl, Validators, UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms"
import { CheckdButtonComponent } from "../../checkd-ui/checkd-button/checkd-button.component"
import { MatInputModule } from "@angular/material/input"
import { MatFormFieldModule } from "@angular/material/form-field"
import { NgIf } from "@angular/common"

@Component({
  selector: "checkd-password-recovery",
  templateUrl: "./password-recovery.component.html",
  styleUrls: ["./password-recovery.component.scss"],
  imports: [NgIf, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, CheckdButtonComponent],
})
export class PasswordRecoveryComponent implements OnInit {
  @Output() submit = new EventEmitter()
  email = new UntypedFormControl("", [Validators.required, Validators.email])
  form: UntypedFormGroup
  wasEmailSubmitted: boolean = false

  constructor(private fb: UntypedFormBuilder) {
    this.form = fb.group({
      email: this.email,
    })
  }

  ngOnInit() {}

  onSubmit(email: string) {
    if (this.email.valid) {
      this.wasEmailSubmitted = true
      this.submit.emit(email)
    }
  }
}
